// extracted by mini-css-extract-plugin
export var container = "ListStyleMarker-module--container--b6ede";
export var marker = "ListStyleMarker-module--marker--f3cb8";